import { useRouter } from "next/router";
import { useLocalStorage } from "usehooks-ts";

const useLocale = () => {
  const router = useRouter();
  const [preferredLocale, setPreferredLocale] = useLocalStorage(
    "preferredLocale",
    null,
  );

  const changeLocale = (locale: any) => {
    setPreferredLocale(locale);
    router.push(router.pathname, router.asPath, { locale });
  };

  // useEffect(() => {
  //   const storedLocale = preferredLocale;
  //   if (storedLocale) {
  //     router.push(router.pathname, router.asPath, { locale: storedLocale });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return { changeLocale };
};

export default useLocale;
